export class ConstantsSonstige {
  static readonly MAX_GESAMTEMISSION_GE_S: number = 50000;

  static readonly FILENAME_WINDDATEN_CSV: string =
    'Winddaten-Import-Vorlage';

  static readonly FILENAME_VDI_AUSZUG_PDF: string =
    'Handhabung VDI Auszug';
}